var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-collapse',{attrs:{"value":[_vm.POLOZKY]}},[_c('dms-collapse-table',{attrs:{"table":_vm.dependentTables.Polozky,"object-name":_vm.POLOZKY,"name":_vm.POLOZKY,"label-key":"PrevDetails"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }